import { Grid, Typography } from '@mui/material';
import RHFDeskTopDatePicker from './RHFDeskTopDatePicker';

type RHFDatePickerProps = {
  openDateName?: string,
  closeDateName?: string
  openDateLabel: string;
  closeDateLabel: string;
  openDateRules: Object;
  closeDateRules: Object;
  title?: string;
  control: any;
  defalutOpenDate: Date | undefined | null;
  defalutCloseDate: Date | undefined | null;
  openDateDisabled?: boolean;
  closeDateDisabled: boolean;
  openDateOnChange?: (value: Date | null) => void;
  closeDateOnChange?: (value: Date | null) => void;
  inputFormat?: string;
  sx?: Object;
  //開始日のキー入力イベント
  openDateOnInput?: (value: any) => void;
  //終了日のキー入力イベント
  closeDateOnInput?: (value: any) => void;
  //日付形式
  mask?: string;
};

const RHFDatePickers = ({
  openDateName = 'openedAt',
  closeDateName = 'closedAt',
  openDateLabel,
  closeDateLabel,
  title,
  control,
  defalutOpenDate,
  defalutCloseDate,
  openDateRules,
  closeDateRules,
  openDateDisabled,
  closeDateDisabled,
  openDateOnChange,
  closeDateOnChange,
  inputFormat,
  sx,
  openDateOnInput,
  closeDateOnInput,
  mask
}: RHFDatePickerProps) => {
  return (
    <Grid item container xs={12} md={12} spacing={1}>
      {title && <Grid item container alignItems="center" justifyContent="center" xs={12} md={4} sx={{ mb: 1 }}>
        <Typography>{title}</Typography>
      </Grid>}
      <Grid item xs={12} md={8}>
        <Grid container direction="row" spacing={2}>
          <Grid item xs={12} md={sx ? "auto" : 6}>
            <RHFDeskTopDatePicker
              control={control}
              name={openDateName}
              label={openDateLabel}
              rules={openDateRules}
              defaultValue={defalutOpenDate}
              disabled={openDateDisabled}
              onChange={openDateOnChange}
              inputFormat={inputFormat}
              sx={sx}
              onInput={openDateOnInput}
              mask={mask}
            />
          </Grid>
          <Grid item xs={12} md={sx ? "auto" : 6}>
            <RHFDeskTopDatePicker
              control={control}
              name={closeDateName}
              label={closeDateLabel}
              rules={closeDateRules}
              defaultValue={defalutCloseDate}
              disabled={closeDateDisabled}
              onChange={closeDateOnChange}
              inputFormat={inputFormat}
              sx={sx}
              onInput={closeDateOnInput}
              mask={mask}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RHFDatePickers;
